import { render, staticRenderFns } from "./PolicyDeductibles.vue?vue&type=template&id=c53174f8"
import script from "./PolicyDeductibles.vue?vue&type=script&lang=ts"
export * from "./PolicyDeductibles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports